import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, Switch, Route } from 'react-router-dom';

import { connect } from 'react-redux';
import OrganizationIndexPage from '../OrganizationIndexPage/OrganizationIndexPage';
import OrganizationDetailPage from '../OrganizationDetailPage/OrganizationDetailPage';

function OrganizationPage(props) {
  return (<Switch>
    <Route path="/admin/organizations/:organizationID" component={OrganizationDetailPage} />
    <Route exact path="/admin/organizations" component={OrganizationIndexPage} />
  </Switch>);
}
// Retrieve data from store as props
function mapStateToProps() {
  return {};
}

OrganizationPage.propTypes = {
  location: PropTypes.object.isRequired,
};

OrganizationPage.contextTypes = {
  router: PropTypes.object,
};

export default withRouter(connect(mapStateToProps)(OrganizationPage));
